<template>
  <div class="family-list container">
    <breadcrumbs
      v-if="isAdmin"
      :breadcrumb-links="[
        {url:userHomeURL, text: 'Admin home'},
        {url:addFamilyURL, text: 'Add families'},
        {text: 'Recipient list'}
      ]"
    />
    <breadcrumbs
      v-else
      :breadcrumb-links="[
        {url:userHomeURL, text: 'Home'},
        {text: 'Recipient list'}
      ]"
    />
    <div class="row">
      <div class="card col-12">
        <h2>View recipients list</h2>
        <p>Recipients are listed below, potential duplicates in our system are flagged for review.</p>
        <warning-message v-if="hasDuplicates" />
        <family-table />
      </div>
    </div>
  </div>
</template>

<script>
import metadata from '../util/metadata';
import routeNames from '../util/routeNames';
import hasDuplicate from '../util/recipHasDuplicates';
import FamilyTable from '../components/FamilyTable';
import WarningMessage from '../components/Messaging/WarningMessage';
import Breadcrumbs from '../components/Breadcrumbs';
import roles from '../util/roles';
import store from '../store/store';

export default {
  name: 'FamilyListPage',
  components: { FamilyTable, WarningMessage, Breadcrumbs },
  metaInfo: {
    title: `Family List | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'The family list page lists out the families you have entered into the system' }
    ]
  },
  data() {
    return {
      userHomeURL: routeNames.HOME.PATH,
      addFamilyURL: routeNames.ADDFAMILY.PATH
    }
  },
  computed: {
    isAdmin() {
      return store.getters.getUserRole === roles.ADMIN;
    },
    hasDuplicates: function() {
      return !!this.$store.getters.getRecipients.find(item => hasDuplicate(item));
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/environment/_variables";
@import "../styles/global/_card";

.family-list {
  .col-md-10 {
    margin: 0 auto;
  }
}
</style>
